const OrganisationCreateForm = () =>
  import(
    /* webpackChunkName: "OrganisationCreateForm" */ './Organisation/OrganisationCreateForm.vue'
  )
const Billing = () => import(/* webpackChunkName: "Billing" */ './Billing/Index.vue')
const Subscribe = () =>
  import(/* webpackChunkName: "Subscribe" */ './Billing/Subscribe.vue')
const Pay = () => import(/* webpackChunkName: "Pay" */ './Billing/Pay.vue')

const Sidebar = () => import(/* webpackChunkName: "Sidebar" */ './Sidebar/Sidebar')
const GlobalSnackbarBag = () =>
  import(
    /* webpackChunkName: "GlobalSnackbarBag" */ './Notifications/GlobalSnackbarBag'
  )
const UserProfileImage = () =>
  import(/* webpackChunkName: "UserProfileImage" */ './User/UserProfileImage')
const UserAccountDeletion = () =>
  import(/* webpackChunkName: "UserAccountDeletion" */ './User/UserAccountDeletion')
const OnboardingFromInvite = () =>
  import(
    /* webpackChunkName: "OnboardingFromInvite" */ './Auth/OnboardingFromInvite'
  )
const OnboardingProcess = () =>
  import(/* webpackChunkName: "OnboardingProcess" */ './Auth/OnboardingProcess')
const ContainerLogin = () =>
  import(/* webpackChunkName: "ContainerLogin" */ './Auth/Login')

export default {
  OrganisationCreateForm,
  Billing,
  Sidebar,
  GlobalSnackbarBag,
  UserProfileImage,
  UserAccountDeletion,
  OnboardingFromInvite,
  OnboardingProcess,
  ContainerLogin,
  Subscribe,
  Pay,
}
